export default scrollTopButton => {
    let scrollPos = window.scrollY;

    const headerAddClass = () => {
        scrollTopButton.classList.add('is-visible');
    }
    const headerRemoveClass = () => {
        scrollTopButton.classList.remove('is-visible');
    }

    window.addEventListener('scroll', function() {
        scrollPos = window.scrollY

        if (scrollPos >= 400) {
            headerAddClass();
        } else {
            headerRemoveClass();
        }
    });

    scrollTopButton.addEventListener('click', () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    });
}